
















































































































































































































































































































import { uniqBy } from 'lodash';
import {Component, Prop} from 'vue-property-decorator';
import Form, { Send } from '@/components/form-base';
import ErrorAggregator from '@/components/errors/error-aggregator.vue';
import tutorial from '@/components/tutorial/tutorial';

import AffiliateNetworkApi from '@/services/rest/bemob/affiliate-network';
import DomainsApi from '@/services/rest/bemob/domains';
import HeaderButtons from '@/components/ui/ui-modal/modal/header-buttons.vue'

import { mixins } from 'vue-class-component';
import ReportMixin from '@/views/reports/mixins/report-mixin';
import WorkspaceSelect from '@/views/reports/pickers/wokrspace-select.vue';
import NoTagFound from '@/views/reports/views/no-tag-found.vue';
import ApiServices from '@/services';
import TutorialMixin from '@/components/tutorial/tutorial-mixin';
import _ from 'lodash'
import PlanLimitsMixin from '@/components/ui/mixins/plan-limits-mixin';
import TagApi from '@/services/rest/bemob/tag';

const md5 = require('md5');

@Component({
  components: {
    ErrorAggregator,
    HeaderButtons,
    WorkspaceSelect,
    NoTagFound
  }
})
export default class CreateAffiliateNetworkDialog extends	mixins<PlanLimitsMixin, Form, ReportMixin, TutorialMixin>(PlanLimitsMixin, Form, ReportMixin, TutorialMixin) {
  @Prop({ default: {} })
  data: any;

  show: boolean = false;
  child: boolean = false;
  affiliateNetworkApi: AffiliateNetworkApi = new AffiliateNetworkApi();
  domainsApi: DomainsApi = new DomainsApi();
  tagApi: TagApi = new TagApi();
  step: number = 1;
  loading: boolean = false;
  form: any = this.defaultForm();

  affiliate_network_id: string = '';

  oldHash: string = '';
  getCurrentHash() {
    return md5(JSON.stringify(this.form));
  }

  get modalTitle(){
    return this.t('Create affiliate network')
  }

  get defaultAffiliateNetworkTemplate() {
    return {
      clickIdPlaceholder: 'REPLACE',
      payoutPlaceholder: 'OPTIONAL',
      transactionIdPlaceholder: 'OPTIONAL',
      statusPlaceholder: 'OPTIONAL'
    };
  }

  defaultForm() {
    return {
      postbackStatusDefault: 'confirm',
      status: 'active',
      tags: [],
      ...this.defaultAffiliateNetworkTemplate
    };
  }

  get introStepsDefault() {
    return {
      2: `<div class='introjs-tooltip__title'>${this.t('Affiliate Network Settings')}</div><div class='introjs-tooltip__content'>${this.t('Specify name of affiliate network')}</div>`,
      3: `<div class='introjs-tooltip__title'>${this.t('Affiliate Network Settings')}</div><div class='introjs-tooltip__content'>${this.t('Create affiliate network element')}</div>`
    };
  }

  get isActionsDisabled() {
    return !!(this.edit && this.aclReadOnly({
      workspaceId: this.form.workspaceId,
      id: this.affiliate_network_id
    }));
  }

  get quickStartSection() {
    return 'affiliate-networks';
  }

  errors: any[] = [];
  errorsControlActive: boolean = false;

  get default_status(): any[] {
    const { t } = (this as any);
    return [
      { name: t('____x.new'), val: 'new' },
      { name: t('Approved'), val: 'confirm' },
      { name: t('Declined'), val: 'decline' },
      { name: t('Chargeback'), val: 'charge' },
      { name: t('Ignore conversion (not to be included in the stats)'), val: 'reject' }
    ];
  }

  async loadData() {
    this.$store.commit('loading', true);

    await this.load()
      .then(() => {
        if (!_.isEmpty(this.data)) {
          this.form = {
            ...this.form,
            ...this.data,
          };
        }

        this.tutorial.form();
        this.oldHash = this.getCurrentHash();
        this.show = true;
      }).finally(() => this.$store.commit('loading', false));
  }

  async mounted() {
    this.$on('error', (e: any, payload: any) => {
      this.$store.commit('loading', false);

      this.errors = this.translateErrors(this.parseErrors(e.data.errors), e.data.message);
      this.errorsControlActive = true;
    });
    
    if(!this.$store.state.cache.trackingDomains.isUploaded){
      await this.domainsApi.trackingDomainsPopulateStoreCache()
    }

    if(!this.$store.state.cache.tags['affiliate-networks'].isUploaded){
      await this.tagApi.populateStoreCache({type:'affiliate-networks'})
    }

    await this.loadData()
  }

  checkClose() {
    if (this.oldHash !== this.getCurrentHash() && !this.isActionsDisabled) {
      this.bus.emit('open-dialog', { name: 'ConfirmDialog', data: { onConfirm: () => this.close() }})
    } else {
      this.close();
    }
  }

  close() {
    this.$emit('close');
  }

  get userTrackingDomain() {
    return this.$store.getters.cache.trackingDomainsObject[this.$store.state.user.trackingDomainId] || {}
  }

  get domainForHttp() {
    return this.userTrackingDomain.domain;
  }

  get domainForHttps() {
    if (this.userTrackingDomain.httpsAvailable) {
      return this.userTrackingDomain.domain;
    } else {
      let newHttpsDomain = this.$store.state.cache.trackingDomains.data.find((item: any) => {
        return item.httpsAvailable;
      });

      return newHttpsDomain
        ? newHttpsDomain.domain
        : '';
    }
  }

  get postbackUrl() {
    return 'http://' + this.domainForHttp
        + `/postback?cid=${this.form.clickIdPlaceholder || 'REPLACE'}`
        + `&payout=${this.form.payoutPlaceholder || 'OPTIONAL'}`
        + `&txid=${this.form.transactionIdPlaceholder || 'OPTIONAL'}`
        + `&status=${this.form.statusPlaceholder || 'OPTIONAL'}`;
  }

  get securePostbackUrl() {
    return 'https://' + this.domainForHttps
        + `/postback?cid=${this.form.clickIdPlaceholder || 'REPLACE'}`
        + `&payout=${this.form.payoutPlaceholder || 'OPTIONAL'}`
        + `&txid=${this.form.transactionIdPlaceholder || 'OPTIONAL'}`
        + `&status=${this.form.statusPlaceholder || 'OPTIONAL'}`;
  }

  get tutorial() {
    return tutorial(this);
  }

  processForm(form){
    const preparedForm = {...form}
    preparedForm.tags=preparedForm?.tags?.map((item)=>item?.id ? item.name : item);
    return preparedForm;
  }

  @Send()
  submit() {
    const { commit } = this.$store;

    commit('loading', true);

    return this.affiliateNetworkApi.postCreate(this.processForm(this.form))
      .then(async () => {
        await ApiServices.getUserProfile();
        this.oldHash = this.getCurrentHash();

        this.bus.emit('refresh-report');
        this.bus.emit('toast-success', this.t('Affiliate Network has been saved'));

        const {name,usePostbackStatuses, acceptDoublePostbacks, postbackOnlyWhiteIps, postbackWhiteIps, hasCustomParamMasking} = this.form;
        this.$mixpanel?.track('affiliate_network_create', {
          name,
          'use_postback_statuses': !!usePostbackStatuses,
          'accept_double_postbacks': !!acceptDoublePostbacks,
          'postback_only_white_ips_enabled': !!postbackOnlyWhiteIps,
          'has_custom_param_masking': !!hasCustomParamMasking,
          ...(this.form.postbackOnlyWhiteIps && {'postback_white_ips': postbackWhiteIps}),
        });

        this.close();
      })
      .finally(() => {
        commit('loading', false);
      });
  }

  /* rewrite  method from mixin*/
  onChangeWorkspace(value: any) {}

  get showPlanLimitsWarning_tags() {
    return this.form.tags?.length && this.hasPlanLimitsRestriction('tagsAffiliateNetworks')
  }

  clearTags(){
    this.form.tags = []
  }
}
